import type { IBodyTax } from '@/types/taxe.types';
import { reactive, ref } from 'vue';

export const taxe_page = ref(1);
export const taxe_id = ref(null);
export const form_taxe_Body = reactive<IBodyTax>({
  name: '',
  rate: '',
  description: '',
  type: 'vat',
  isActive: true,
});

export const isAtcivatedWatch = ref(false);
export const isAtcivatedWatchTaxe = ref(false);
export const isUpdateFromTaxeActivated = ref(false);
export const isDeletedFromTaxe = ref(false);
